/**
* Build Reading List JS
* -----------------------------------------------------------------------------
*
* All the JS for the Build Reading List component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'build-reading-list',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.clear-list-btn' ).on( 'click', function( event ) {
        event.preventDefault();

        // clear inputs
        $( '.reading-list__input' ).prop( 'checked', false );

        // clear out filter buttons
        $( '.reading-list__selected' ).empty();
      } );

      $( '.reading-list__input' ).on( 'change', function() {
        if ( !$( '.reading-list__container' ).hasClass( 'selection' ) ) {
          $( '.reading-list__container' ).addClass( 'selection' );
        }

        // get the value and text for filter button
        const value = $( this ).val();
        const text = $( this ).next().find( '.reading-list__title' ).text();

        // check if its a date button and if so make sure the others are unclicked
        if ( $( this ).attr( 'name' ) === 'query_date[]' ) {
          if ( $( this ).is( ':checked' ) ) {
            // the name of the box is retrieved using the .attr() method
            // as it is assumed and expected to be immutable
            const group = 'input:checkbox[name=\'' + $( this ).attr( 'name' ) + '\']';

            // the checked state of the group/box on the other hand will change
            // and the current value is retrieved using .prop() method
            $( group ).prop( 'checked', false );
            $( this ).prop( 'checked', true );
          } else {
            $( this ).prop( 'checked', false );
          }
        }

        // add button to selected seciton
        // check if the button already exists
        if ( $( `:button[value="${value}"]` ).length ) {
          $( `:button[value="${value}"]` ).remove();
        } else {
          if ( $( this ).attr( 'name' ) === 'query_date[]' ) {
            if ( $( `:button` ).hasClass( 'date-btn' ) ) {
              $( '.date-btn' ).remove();
            }
            $( '.reading-list__selected' ).append( `<button type="button" value="${value}" class="date-btn focus:outline-none mb-3 mr-3 reading-list__selected-btn bg-white btn-tag">${text}<svg class="icon icon-tag-delete-x"><use xlink:href="#icon-tag-delete-x"></use></svg></button>` );
          } else {
            $( '.reading-list__selected' ).append( `<button type="button" value="${value}" class="focus:outline-none mb-3 mr-3 reading-list__selected-btn bg-white btn-tag">${text}<svg class="icon icon-tag-delete-x"><use xlink:href="#icon-tag-delete-x"></use></svg></button>` );
          }
        }
      } );

      // Add event listenter to dynmically created buttons
      const addSelectedListener = () => {
        $( '.reading-list__selected' ).on( 'click', '.reading-list__selected-btn', function() {
          // adds removes padding if the box is empty
          if ( $( '.reading-list__selected' ).children().length < 2 ) {
            $( '.reading-list__container' ).removeClass( 'selection' );
          }
          const value = $( this ).val( );
          $( `input[value="${value}"]` ).prop( 'checked', false );
          $( this ).remove();
        } );
      };

      addSelectedListener();
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'build-reading-list', COMPONENT );
} )( app );
